import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
    private _featureFlags: Core.FeatureFlags;
    private _resolveReady: (featureFlags: Core.FeatureFlags) => void;
    private readonly _ready = new Promise<Core.FeatureFlags>((resolve) => {
        this._resolveReady = resolve;
    });

    get featureFlags(): Core.FeatureFlags {
        return this._featureFlags;
    }

    set featureFlags(value: Core.FeatureFlags) {
        this._featureFlags = value;
        if (value) {
            this._resolveReady(value);
        }
    }

    whenReady(): Promise<Core.FeatureFlags> {
        return this._ready;
    }

    get taxDotComBase(): string {
        let base = this.featureFlags.taxDotComBase;
        if (base.endsWith('/')) {
            base = base.substring(0, base.length - 1);
        }
        return base;
    }

    get environment(): string {
        return this.featureFlags.environment;
    }
}
